import React from 'react'
import { connect } from 'react-redux'
import './Approach.css'
import i18n from '../../i18n'
import { setSelectedApproach, saveApproach } from '../../actions/data'

class Approach extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      selectedOption: null,
      selectedButtonIndex: null
    }
  }

  handleStrategyButtonClick = (option, index) => {
    this.setState({
      selectedOption: option,
      selectedButtonIndex: index
    })
    window.scrollTo(141, 610)
    this.props.setSelectedApproach(option)
  }

  render() {
    // console.log(this.state);
    const orderedOptions = ['Global Dividend', 'Strategic'];

    return (
      <div className='approach'>
        <div>
          <div className='approach-title'>{i18n.t('welcome')}</div>
          <div className='approach-subtitle'>{i18n.t('goal')}</div>
          {/* <div className='approach-subtitle'>{i18n.t('approach_text2')}</div> */}
        </div>
        <div>
          <div className='approach-options'>
            {orderedOptions.map((option, index) => (
              <button
                key={index}
                className={
                  this.state.selectedButtonIndex === index ? 'approach-selectedOption' : 'approach-option'
                }
                onClick={() => this.handleStrategyButtonClick(option, index)}
              >
                {option === 'Global Dividend'
                  ? 'Income'
                  : option === 'Strategic'
                    ? 'Growth'
                    : option}
              </button>
            ))}
          </div>
        </div>
        <div>
          <div className='approachNextButtonContainer'>
            <button
              className={this.state.selectedOption !== null ? 'approachNextButton' : 'approachNextButtonDisabled'}
              onClick={() => this.props.saveApproach(this.state.selectedOption)}
              disabled={this.state.selectedOption === null}
            >
              Next
            </button>
          </div>
        </div>
      </div>
    )
  }
}

const mapDispatchToProps = dispatch => ({
  setSelectedApproach: value => dispatch(setSelectedApproach(value)),
  saveApproach: value => dispatch(saveApproach(value))
})

export default connect(null, mapDispatchToProps)(Approach)